// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e1b4cbb5","977":"ed69c1f7"}[chunkId] + ".chunk.js";
};